<template>
  <div>
    <div class="wrap coach-recom-wrap pb-30">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약하기</h3>
      </div>
      <div class="body-wrap" v-if="!isMailRecom">
        <div class="recomm">
          <h4>
            나에게 딱 맞는<br />
            <span class="bold">코치 추천! </span>
          </h4>
          <div class="coach-slide">
            <div v-if="rebook == 1">
              <div v-if="isLoading">
                <VueSlickCarousel v-bind="settings">
                  <div class="coach-card" @click="next(item.coarIdx)" v-for="(item, index) in rebookCoarch" :key="index">
                    <div class="clear profile">
                      <img src="@/assets/img/coach_bg.png" class="bg" />
                      <img :src="item.coarPic" class="profile-img" alt="코치 이미지" style="width: 100%" />
                      <div class="card-point clear" v-if="item.isCurrentCoach">
                        <img src="@/assets/img/return.svg" />
                        <p>이번 코칭도 {{ item.userName }} 코치님과<br />계속 이어가 보세요.</p>
                      </div>
                    </div>
                    <div class="info">
                      <h1>{{ item.userName }} <span>코치</span></h1>
                      <p>{{ item.coarOnelineIntroduction }}</p>
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
            <div v-if="rebook == 0">
              <div v-if="isLoading">
                <div v-if="coarchList.length">
                  <VueSlickCarousel v-bind="settings">
                    <div class="coach-card" @click="next(item.coarIdx)" v-for="(item, index) in coarchList" :key="index">
                      <div class="clear profile">
                        <img src="@/assets/img/coach_bg.png" class="bg" />
                        <img :src="item.coarPic" class="profile-img" alt="코치 이미지" style="width: 100%" />
                      </div>
                      <div class="info">
                        <h1>{{ item.userName }} <span>코치</span></h1>
                        <p>{{ item.coarOnelineIntroduction }}</p>
                      </div>
                    </div>
                  </VueSlickCarousel>
                </div>
                <div v-else>
                  <VueSlickCarousel v-bind="settings">
                    <div class="coach-card" @click="next(item.coarIdx)" v-for="(item, index) in generalCoarchList" :key="index">
                      <div class="clear profile">
                        <img src="@/assets/img/coach_bg.png" class="bg" />
                        <img :src="item.coarPic" class="profile-img" alt="코치 이미지" style="width: 100%" />
                      </div>
                      <div class="info">
                        <h1>{{ item.userName }} <span>코치</span></h1>
                        <p>{{ item.coarOnelineIntroduction }}</p>
                      </div>
                    </div>
                  </VueSlickCarousel>
                </div>
              </div>
            </div>
          </div>
          <div class="side" v-if="isCategoryLimit == 1">
            <h2>다른 코치님도 보고 싶으신가요?</h2>
            <p v-if="!isReRecom" @click="reCoarch()">재추천 받기</p>
            <p v-else>
              <span @click="originCoarch()" class="mr-20">이전 코치 추천 보기</span>
              <!-- |
                            <span class="ml-20" @click="emailRecom()">메일로 재추천 받기</span> -->
            </p>
          </div>
        </div>
      </div>
      <div class="finish-wrap" v-if="isMailRecom">
        <div class="body-wrap">
          <img src="@/assets/img/finish-check.svg" alt="완료" />
          <h3>BnB 매니저가 직접 코치님을 엄선하여<br />메일로 추천드릴게요!</h3>
          <h4>조금만 기다려 주세요!</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "coach_recom",
  props: {
    rebook: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    settings: {
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    },
    recomSubjectData: [],
    coarchList: [],
    generalCoarchList: [],
    originCoarchList: [],
    isReRecom: false,
    isLoading: false,
    isCategoryLimit: 0,
    isMailRecom: false,
    rebookCoarch: [],
    currentCoach: {},
  }),
  components: {
    VueSlickCarousel,
    incBack,
  },
  mounted() {
    console.log("pageFunc", this.$store.state.pageFunc);
    this.recomSubjectData = JSON.parse(localStorage.getItem("recomSubjectData"));
    if (this.rebook == 1) {
      this.getCurrentRcomCoarch();
    } else {
      if (this.$store.state.isReRecom == "0") {
        if (this.$store.state.courseInfo.courseEmbeddedSurvey == "Y") {
          this.isCategoryLimit = 1;
          this.getCoarch();
        } else {
          this.isCategoryLimit = 0;
          this.getGeneralCoarch();
        }
      } else {
        this.isCategoryLimit = 1;
        this.reCoarch();
      }
    }
  },
  methods: {
    getCurrentRcomCoarch() {
      console.log(this.$store.state.courseInfo);
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/user/recommendCoarch/last", { params })
        .then((res) => {
          if (res.data.success) {
            this.currentCoach = res.data.data;
            if (this.$store.state.courseInfo.courseEmbeddedSurvey == "Y") {
              this.getRecommendCoarch();
            } else {
              this.$store.commit("setpageFunc", "1");
              this.getGeneralCoarch();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRecommendCoarch() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/user/recommendCoarch/allready", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            let coarch = res.data.data;
            for (let item of coarch) {
              if (this.currentCoach.length) {
                if (item.coarIdx == this.currentCoach[0].coarIdx) {
                  item.isCurrentCoach = true;
                } else {
                  item.isCurrentCoach = false;
                }
              } else {
                item.isCurrentCoach = false;
              }

              this.rebookCoarch.push(item);
            }
            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    emailRecom() {
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/user/recommendCoarch/mail", { params })
        .then((res) => {
          if (res.data.success) {
            this.isMailRecom = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    originCoarch() {
      // this.coarchList = [];
      // this.coarchList = this.originCoarchList;
      this.isLoading = false;
      this.getCoarch();
      this.$store.commit("setIsReRcom", "0");
      // this.$store.commit("setIsReCoach","0");
      this.isReRecom = false;
      this.isLoading = true;
    },
    reCoarch() {
      this.isLoading = false;
      this.originCoarchList = this.coarchList;
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
        pagefunc: "0",
      };
      this.axios
        .get("/front/user/recommendCoarch/relist", { params })
        .then((res) => {
          if (res.data.success) {
            this.coarchList = res.data.data;
            this.$store.commit("setIsReCoach", "1");
            this.$store.commit("setIsReRcom", "1");
            console.log("reCoach", this.$store.state.isReCoach);
            this.isReRecom = true;
            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // this.isReRecom = true;
    },
    getGeneralCoarch() {
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
        pagefunc: this.$store.state.pageFunc,
      };
      this.axios
        .get("/front/user/recommendCoarch/mainarea/same", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            if (this.rebook == 1) {
              let coarch = res.data.data;
              for (let item of coarch) {
                item.isCurrentCoach = false;
                item.userName = item.coarchName;

                if (this.currentCoach.length) {
                  if (item.coarIdx == this.currentCoach[0].coarIdx) {
                    item.isCurrentCoach = true;
                  } else {
                    item.isCurrentCoach = false;
                  }
                } else {
                  item.isCurrentCoach = false;
                }
                this.rebookCoarch.push(item);
              }
            } else {
              let coachTemp = res.data.data;
              for (let item of coachTemp) {
                item.userName = item.coarchName;
              }
              if (this.$store.state.courseInfo.courseCategoryLimit == "1") {
                this.generalCoarchList = coachTemp;
              } else {
                this.coarchList = coachTemp;
              }
              this.$store.commit("setpageFunc", "1");
            }
            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCoarch() {
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
        pagefunc: this.$store.state.pageFunc,
      };
      console.log(params);
      this.axios
        .get("/front/user/recommendCoarch/list", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.coarchList = res.data.data;
            this.$store.commit("setpageFunc", "1");
            if (!this.coarchList.length) {
              this.getGeneralCoarch();
            } else {
              this.isLoading = true;
            }
            // this.getGeneralCoarch();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next(idx) {
      this.$router.push({ name: "coach_view", params: { idx: idx, rebook: this.rebook } });
    },
  },
};
</script>
